<!-- START: Preview Document  -->
<div class="col-12">
  <div
    class="modal fade preview-modal"
    bsModal
    #previewDocumentModal="bs-modal"
    [config]="{ backdrop: 'static' }"
    role="dialog"
    aria-labelledby="dialog-static-name"
  >
    <div class="modal-dialog modal-xl" style="bottom: 1.25vw">
      <div class="modal-content">
        <div class="modal-header">
          <label
            id="dialog-nested-name3"
            class="modal-title pull-left blueColoredText fs-13-vw fw-600"
            >Preview</label
          >
          <button
            type="button"
            class="btn-close close pull-right shadow-none"
            aria-label="Close"
            (click)="previewDocumentModal.hide()"
          >
            <span aria-hidden="true" class="visually-hidden">&times;</span>
          </button>
        </div>
        <div class="modal-body mt-3-vw">
          <div class="row">
            <div class="col-12">
              <!-- Image preview -->
              <img
                *ngIf="previewUrl && documentType && documentType == 'image'"
                [src]="previewUrl"
                height="400"
                style="width: 100%"
              />

              <!-- PDF preview -->
              <iframe
                *ngIf="previewUrl && documentType && documentType == 'pdf'"
                [src]="previewUrl"
                height="400"
                style="width: 100%"
              ></iframe>

              <div
                #docContainer
                style="height: 30vw; overflow-y: auto"
                *ngIf="documentType && documentType == 'doc'"
              ></div>

              <div class="row justify-content-end mt-2-vw">
                <div
                  class="col-8 d-flex justify-content-end"
                  *ngIf="documentType"
                >
                  <button
                    type="button"
                    class="btn primaryButton rounded fs-14-vw fw-600 cursor"
                    (click)="downloadFile()"
                  >
                    Download File
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- END: Preview Document  -->
